import Backbone from 'backbone'
import $ from 'jquery'

/*
 * Edges is a support mixin to canvas that draws a div around the wob area. Unlike a lot of other
 * canvas support objects, this element is inserted in the canvas `.wobs`. This is required since edges
 * can be used in a scalable canvas. Since canvas edges creates an absolute positioned node, it wouldn't
 * receive the scale transformations applied, so we add it into the relative positioned `.wobs` container.
 */
var Edges = Backbone.View.extend({

  initialize: function (options) {
    this.canvas = options.canvas
    this.listenTo(this.canvas, 'resize', this.resize, this) // Anytime the canvas is resized, resize the edges
    this.listenTo(this.canvas.collection, 'move change:rotate', () => this.resize(), this) // Adjust the edge size as the user moves wobs. Make sure to ignore the 'move' arguments and invoke resize so the bounding box is recalculated
  },

  render: function () {
    this.$('.wobs').prepend($('<div>').addClass('canvas-edges'))
    return this
  },

  resize: function (bb, opts = {}) {
    bb = bb || this.canvas.boundingBox()

    let el = this.$('.wobs .canvas-edges')
      , padding = this.canvas.padding * 2
      , dim = {
        width: padding + bb.maxX,
        height: padding + bb.maxY,
      }

    el.toggleClass('animated-paint', opts.animate === true)
      .css(dim) // Sets the dimensions manually so jQuery's `height()/width()` don't adjust for border-radius/border-width scaling. See SB3 #24543

    if (opts.animate === true) {
      setTimeout(() => el.removeClass('animated-paint'), this.canvas.animation_duration)
    }

    return this
  }

})

export default function (canvas) {
  return new Edges({canvas: canvas, el: canvas.el}).render()
}
